



























import { Type } from 'expangine-runtime';
import TypeInputBase from './TypeInputBase';


export default TypeInputBase<Type, any, any>().extend({
  
});
